import { gql } from "@apollo/client";

export const GET_JOBS_BY_OBJECT_ID = gql`
  query GetJobsByObjectId($id: String!) {
    allJobsByObjectId(id: $id) {
      id
      description
      createdBy
      severity
      title
      startDate
      endDate
      status
      createdByUsername
    }
  }
`;

export const GET_JOBS_BY_PROJECT_ID = gql`
  query GetJobsByProjectId($id: String!) {
    allJobsByProjectId(id: $id) {
      id
      description
      createdBy
      severity
      title
      startDate
      endDate
      status
      objectId
      createdByUsername
    }
  }
`;

export const GET_JOB_BY_ID = gql`
  query GetJobById($id: BigInteger!) {
    jobById(id: $id) {
      id
      description
      createdBy
      severity
      title
      startDate
      endDate
      status
    }
  }
`;

export const CREATE_JOB = gql`
  mutation CreateJob($input: MdmObjectJobDTOInput!) {
    createJob(mdmObjectJob: $input) {
      id
      description
      createdBy
      severity
      title
      startDate
      endDate
      status
    }
  }
`;

export const UPDATE_JOB = gql`
  mutation UpdateJob($input: MdmObjectJobDTOInput!) {
    updateJob(mdmObjectJob: $input) {
      id
      description
      createdBy
      severity
      title
      startDate
      endDate
      status
    }
  }
`;

export const DELETE_JOB = gql`
  mutation DeleteJob($jobId: BigInteger!) {
    deleteJob(id: $jobId) {
      id
    }
  }
`;